import { User } from "@/connectors/remp/types/rempTypes";
import { subsURL } from "@/constants/reporter";
import useUserProvider from "@/core/dataProviders/providers/auth/useUserProvider";
import useUserSubscriptionProvider from "@/core/dataProviders/providers/auth/useUserSubscriptionProvider";
import { useEffect, useState } from "react";
import { addQueryParamToUrl } from "@/utils/addQueryParamToUrl";
import { useReferrerUrl } from "@/hooks/useReferrerUrl";

export default function useCurrentSubscriptionInfo(dynamicTitle?: string, dynamicURL?: string) {
  const [user] = useUserProvider();
  const [subscriptions] = useUserSubscriptionProvider();
  const [activeUser, setActiveUser] = useState<User | null | undefined>(null);
  const { getReferrerUrlWithParams } = useReferrerUrl();

  useEffect(() => {
    setActiveUser(user);
  }, [user]);

  const getDynamicSubscriptionTitle = () => {
    if (activeUser === null) {
      return null;
    }
    if (user && !!subscriptions?.length && dynamicTitle?.includes("Předplatné")) {
      return "Darujte předplatné";
    }
    return dynamicTitle;
  };

  const getStaticSubscriptionTitle = () => {
    if (activeUser === null) {
      return null;
    }
    if (user && !!subscriptions?.length) {
      return "Darujte předplatné";
    }
    return "Předplatné";
  };

  const getDynamicSubscriptionURL = (postId?: number) => {
    if (activeUser === null) {
      return "/";
    }
    if (user && !!subscriptions?.length && dynamicTitle?.includes("Předplatné")) {
      let url = subsURL.GIFT_SUBS_URL;

      if (postId) {
        const referrerUrl = getReferrerUrlWithParams([{ key: "article_id", value: postId.toString() }]);

        url = addQueryParamToUrl(url, "referrer", referrerUrl);
      }

      return url;
    }

    let url = dynamicURL;

    if (postId && url) {
      const referrerUrl = getReferrerUrlWithParams([{ key: "article_id", value: postId.toString() }]);

      url = addQueryParamToUrl(url, "referrer", referrerUrl);
    }

    return url;
  };

  const getStaticSubscriptionURL = (postId?: number) => {
    if (activeUser === null) {
      return "/";
    }

    let url = subsURL.ALL_SUBS_URL;

    if (user && !!subscriptions?.length) {
      url = subsURL.GIFT_SUBS_URL;
    }

    if (postId) {
      const referrerUrl = getReferrerUrlWithParams([{ key: "article_id", value: postId.toString() }]);

      url = addQueryParamToUrl(url, "referrer", referrerUrl);
    }

    return url;
  };

  return {
    getDynamicSubscriptionTitle,
    getStaticSubscriptionTitle,
    getDynamicSubscriptionURL,
    getStaticSubscriptionURL,
  };
}
